import { render, staticRenderFns } from "./BatchPromotionItems.vue?vue&type=template&id=0315ae11"
import script from "./BatchPromotionItems.vue?vue&type=script&lang=js"
export * from "./BatchPromotionItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports